// extracted by mini-css-extract-plugin
module.exports = {"pintxo-drag-handler":"Drawer_pintxo-drag-handler__EPY4c","pintxo-drag-handler--dragging":"Drawer_pintxo-drag-handler--dragging__gYinb"};